// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  TelemetryValueType,
} from "./types";


export default __t.row({
  mappingId: __t.u64().primaryKey().name("mapping_id"),
  endpointId: __t.u64().name("endpoint_id"),
  jsonPath: __t.string().name("json_path"),
  targetStreamName: __t.string().name("target_stream_name"),
  targetTwinId: __t.string().name("target_twin_id"),
  get valueType() {
    return TelemetryValueType.name("value_type");
  },
  eventTimeJsonPath: __t.string().name("event_time_json_path"),
  eventTimeFormat: __t.string().name("event_time_format"),
  description: __t.string(),
  enabled: __t.bool(),
  targetComponent: __t.string().name("target_component"),
  detectedType: __t.string().name("detected_type"),
  scaleFactor: __t.f64().name("scale_factor"),
  lastEventTimeMicros: __t.i64().name("last_event_time_micros"),
});
